import { WorkerProfile } from 'src/DTO/WorkerProfile.type';

export const toggleWorkers = (
  worker: WorkerProfile,
  selectedWorkers: WorkerProfile[],
  setSelectedWorkers: React.Dispatch<React.SetStateAction<WorkerProfile[]>>,
) => {
  const existingWorker = selectedWorkers.find(selectedWorker => selectedWorker.id === worker.id);

  if (existingWorker) {
    setSelectedWorkers(
      selectedWorkers.filter(selectedWorker => selectedWorker.id !== existingWorker.id),
    );
  } else {
    setSelectedWorkers([...selectedWorkers, worker]);
  }
};
